import React from "react";

import Grid from "../Grid/Grid";
import GridItem from "../GridItem/GridItem";
import { TagsList } from "../TagsList/TagsList";

import "./tagsCard.css";

export const TagsCard = ({ tagsList }) => {
  return (
    <>
      <Grid center>
        <GridItem md={12} lg={8}>
          <article className="coop-c-tagscard coop-u-margin-resp-t-48-32">
            <div className="coop-c-tagscard__inner">
              <h3 className="coop-c-tagscard__title coop-t-h2">Related tags</h3>
              <TagsList tagsList={tagsList} />
            </div>
          </article>
        </GridItem>
      </Grid>
    </>
  );
};
